import React from 'react';
import Tabs from './SeminarTabs';

const SeminarTabs = (props) => (
  <Tabs {...props} />
);

export default SeminarTabs;



// WEBPACK FOOTER //
// ./src/components/SeminarTabs/index.js